import { Supporters } from './Supporters';
import { connect } from 'react-redux'
import { withApollo } from 'react-apollo';


const mapStateToProps = ({
	cmsData: {
		supporters
	}
}, ownProps) => {
	return {
    supporters: {
        ...supporters
    }
	}
}

export default connect(
  mapStateToProps,
)(withApollo(Supporters));

